import { vue } from '@/main'

export default function () {
  return [

    {
      key: 'orgIds',
      type: 'org',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      key: 'buTypes',
      label: 'departments',
      type: 'department',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
    {
      key: 'buIds',
      label: 'businessUnit',
      type: 'bu',
      props: {
        clearable: true,
        multiple: true
      },
      collapsed: true,
      collapsedMinWidth: "450px",
    },
 /*    { key: 'banner' }, { key: 'affiliate' }, { key: 'campaign' }, */

  ]
}
